import React from 'react'
import Avatar from '../Avatar'
import { connect } from 'react-redux'
import {
  UserName,
  Datetime,
  Text,
  CommentTextXs,
  ConfirmXs,
  CancelXs
} from './styles'
import { getDuration } from 'src/utils'
import * as firebase from 'firebase'
import Icon from '../Icon'
import { dispatch } from '../../store'
import { Flex, Box } from '@rebass/grid'

class ReplyItem extends React.Component {
  state = {
    editing: false,
    replyText: this.props.reply.text
  }
  render() {
    const currentUser = firebase.auth().currentUser
    const { author, reply, discussion } = this.props
    const { editing } = this.state
    return (
      <Flex>
        <Box width={32} mr={12}>
          <Avatar userId={reply.authorId} fluid={true} />
        </Box>
        <Flex flex={1} flexDirection="column">
          <Flex justifyContent="space-between" mb={1}>
            <UserName>{author ? author.fullName : '講者'}</UserName>
            <Datetime>{getDuration(reply.ts)}</Datetime>
          </Flex>
          <Box>
            {!editing ? (
              <Flex justifyContent="space-between">
                <Box>
                  <Text>{reply.text}</Text>
                </Box>
                {currentUser && reply.authorId === currentUser.uid ? (
                  <Box width={30} ml={4}>
                    <Icon
                      type="edit"
                      onClick={() => this.setState({ editing: true })}
                    />
                  </Box>
                ) : null}
              </Flex>
            ) : (
              <Box py={1}>
                <CommentTextXs
                  autoFocus={true}
                  value={this.state.replyText}
                  onChange={e => this.setState({ replyText: e.target.value })}
                />
                <CancelXs
                  onClick={() => {
                    this.setState({
                      editing: false,
                      replyText: reply.text
                    })
                  }}
                >
                  取消
                </CancelXs>
                <ConfirmXs
                  onClick={() => {
                    dispatch.lectureDiscussion
                      .updateReply({
                        discussionId: discussion.id,
                        replyId: reply.id,
                        text: this.state.replyText
                      })
                      .then(_ => this.setState({ editing: false }))
                  }}
                >
                  確定
                </ConfirmXs>
              </Box>
            )}
          </Box>
        </Flex>
      </Flex>
    )
  }
}
const mapState = (models, ownProps) => ({
  author:
    models.users && models.users[ownProps.reply.authorId]
      ? models.users[ownProps.reply.authorId]
      : null
})

export default connect(mapState)(ReplyItem)



// WEBPACK FOOTER //
// ./src/components/LectureComment/ReplyItem.js